import { __extends } from "tslib";
import { PhoneNumberValidateRequest, PhoneNumberValidateResponse } from "../models/index";
import { deserializeAws_restJson1PhoneNumberValidateCommand, serializeAws_restJson1PhoneNumberValidateCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var PhoneNumberValidateCommand = /** @class */ (function (_super) {
    __extends(PhoneNumberValidateCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PhoneNumberValidateCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    PhoneNumberValidateCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: PhoneNumberValidateRequest.filterSensitiveLog,
            outputFilterSensitiveLog: PhoneNumberValidateResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PhoneNumberValidateCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1PhoneNumberValidateCommand(input, context);
    };
    PhoneNumberValidateCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1PhoneNumberValidateCommand(output, context);
    };
    return PhoneNumberValidateCommand;
}($Command));
export { PhoneNumberValidateCommand };
//# sourceMappingURL=PhoneNumberValidateCommand.js.map